import OneInchColorBlack from '@uikit/icons/OneInchColorBlack';

import { Tabular } from '@ui/uikit/primitives/Tabular';

import { SwapSlippageControl } from '../specialized/SwapSlippageControl';
import { SwapOperationFeeIndicator } from './SwapOperationFeeIndicator';

const SwapOperationMetadata = () => {
  return (
    <div className="rounded-[16px] p-[16px] bg-primary-50 border-2 border-primary-50">
      <Tabular className="tabular-uniform [&>.label]:text-neutral-400 [&>.content]:text-neutral-500">
        <Tabular.Row label="Provider">
          <OneInchColorBlack className="h-[32px]" />
        </Tabular.Row>

        <Tabular.Row label="Transaction fee">
          <SwapOperationFeeIndicator />
        </Tabular.Row>

        <Tabular.Row label="Slippage tolerance">
          <SwapSlippageControl />
        </Tabular.Row>
      </Tabular>
    </div>
  );
};

export { SwapOperationMetadata };
